export default __webpack_public_path__ + "static/media/rollup.fbb47c91.jpg";